// components
import { useLocalStorageJson } from '@/hooks/useLocalStorageJson';

export interface DataViewerSettings {
  yAxisStartsAtZero: boolean;
  showAllSeriesByDefault: boolean;
}

const STORAGE_KEY = 'data-viewer-settings';

export const DEFAULT_DATA_VIEWER_SETTINGS: DataViewerSettings = {
  yAxisStartsAtZero: false,
  showAllSeriesByDefault: false,
};

export default function useDataViewerSettings(): [
  DataViewerSettings,
  (patch: Partial<DataViewerSettings>) => void,
] {
  const [stored, setStored] = useLocalStorageJson(
    STORAGE_KEY,
    DEFAULT_DATA_VIEWER_SETTINGS,
  );

  const settings: DataViewerSettings = {
    ...DEFAULT_DATA_VIEWER_SETTINGS,
    ...stored,
  };

  const updateSettings = (patch: Partial<DataViewerSettings>) =>
    setStored({ ...settings, ...patch });

  return [settings, updateSettings];
}
